import { defineComponent } from 'vue';
export default defineComponent({
    props: {
        direction: {
            type: String,
            default: 'horizontal',
        },
        justify: {
            type: String,
            default: null,
        },
        align: {
            type: String,
            default: null,
        },
        wrap: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        classMap() {
            let classMap = {
                'flex-column': this.direction == 'vertical',
                'flex-wrap': this.wrap,
            };
            if (this.direction == 'horizontal') {
                classMap = {
                    ...classMap,
                    'justify-content-start': this.justify == 'left',
                    'justify-content-end': this.justify == 'right',
                    'justify-content-center': this.justify == 'center',
                    'justify-content-between': this.justify == 'spread',
                    'justify-content-around': this.justify == 'around',
                    'align-items-start': this.align == 'top',
                    'align-items-end': this.align == 'bottom',
                    'align-items-center': this.align == 'center',
                };
            }
            else {
                classMap = {
                    ...classMap,
                    'justify-content-start': this.align == 'top',
                    'justify-content-end': this.align == 'bottom',
                    'justify-content-center': this.align == 'center',
                    'justify-content-between': this.align == 'spread',
                    'justify-content-around': this.align == 'around',
                    'align-items-start': this.justify == 'left',
                    'align-items-end': this.justify == 'right',
                    'align-items-center': this.justify == 'center',
                };
            }
            return classMap;
        },
    },
});
